import type { Channel, ChatMessage, Draft, Provider } from './types';

export const providerLabels: Record<Provider, string> = {
  tiktok: 'TikTok',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'YouTube',
};

export const channels: Channel[] = [
  {
    id: 'ch_tiktok_demo',
    provider: 'tiktok',
    name: 'Northstar League',
    handle: '@northstarleague',
    status: 'connected',
    audience: '28.4K',
    lastSync: '2 min ago',
  },
  {
    id: 'ch_instagram_demo',
    provider: 'instagram',
    name: 'Northstar League',
    handle: '@northstar.league',
    status: 'connected',
    audience: '12.8K',
    lastSync: '2 min ago',
  },
  {
    id: 'ch_youtube_demo',
    provider: 'youtube',
    name: 'Northstar League',
    handle: '@NorthstarLeague',
    status: 'connected',
    audience: '7.3K',
    lastSync: '4 min ago',
  },
  {
    id: 'ch_facebook_demo',
    provider: 'facebook',
    name: 'Northstar League',
    handle: 'Northstar League',
    status: 'attention',
    audience: '5.1K',
    lastSync: 'Token needs renewal',
  },
];

export const drafts: Draft[] = [
  {
    id: 'draft_1',
    title: 'The final round changed everything',
    body: 'Three angles. One impossible comeback. Here is the moment the bracket flipped.',
    status: 'approved',
    format: 'short',
    scheduledFor: 'Today · 6:30 PM',
    channels: ['tiktok', 'instagram', 'youtube'],
    score: 94,
  },
  {
    id: 'draft_2',
    title: 'Meet the captains',
    body: 'Four teams. Four different approaches. One weekend to settle it.',
    status: 'draft',
    format: 'carousel',
    channels: ['instagram', 'facebook'],
    score: 88,
  },
  {
    id: 'draft_3',
    title: 'Weekend schedule reveal',
    body: 'Save this. Every match, stream, and result from Friday through Sunday.',
    status: 'scheduled',
    format: 'image',
    scheduledFor: 'Tomorrow · 9:00 AM',
    channels: ['facebook', 'instagram'],
    score: 91,
  },
  {
    id: 'draft_4',
    title: 'What the replay missed',
    body: 'The winning move started eight seconds earlier. Watch the setup from every angle.',
    status: 'idea',
    format: 'short',
    channels: ['tiktok', 'youtube'],
    score: 86,
  },
];

export const initialMessages: ChatMessage[] = [
  {
    id: 'hello',
    role: 'assistant',
    text: "Good morning. I checked this week's plan, your connected channels, and the clips waiting for review. You have one strong opening tonight and two empty spots this weekend.",
  },
  {
    id: 'plan',
    role: 'assistant',
    text: 'I can turn the semifinal comeback into three platform-ready versions, then show you every destination and setting before anything is scheduled.',
    card: 'drafts',
  },
];

export const week = [
  { day: 'Mon', date: '10', count: 2 },
  { day: 'Tue', date: '11', count: 1 },
  { day: 'Wed', date: '12', count: 3 },
  { day: 'Thu', date: '13', count: 1 },
  { day: 'Fri', date: '14', count: 2 },
  { day: 'Sat', date: '15', count: 0 },
  { day: 'Sun', date: '16', count: 0 },
];

